import {
  ArchiveIcon,
  BarcodeIcon,
  BotIcon,
  Building2Icon,
  ChartLineIcon,
  CopyIcon,
  CopyPlusIcon,
  FileSpreadsheet,
  FileTextIcon,
  MailIcon,
  NetworkIcon,
  RulerIcon,
  ShoppingBag,
  SquareTerminalIcon,
  StoreIcon,
  WorkflowIcon,
} from "lucide-react";

export const menu = {
  navMain: [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: ChartLineIcon,
      key: "dashboard",
    },
    {
      title: "Users",
      url: "/users",
      icon: BotIcon,
      key: "users",
    },
    {
      title: "Roles",
      url: "/roles",
      icon: BotIcon,
      key: "roles",
    },
    {
      title: "Company",
      url: "/company",
      icon: Building2Icon,
      key: "company",
    },
    {
      title: "SKU Mapping",
      url: "/sku-mapping",
      icon: BarcodeIcon,
      key: "sku_mapping",
    },
    {
      title: "UOM Mapping",
      url: "/uom-mapping",
      icon: RulerIcon,
      key: "uom_mapping",
    },
    {
      title: "Retailer",
      url: "/retailer",
      icon: StoreIcon,
      key: "retailer",
    },
    {
      title: "Retailer Grouping",
      url: "/retailer-grouping",
      icon: ShoppingBag,
      key: "retailer_grouping",
    },
    {
      title: "Synonym",
      url: "/synonym",
      icon: CopyIcon,
      key: "synonym_mapping",
    },
    {
      title: "Email Inbox",
      url: "/email-inbox",
      icon: ArchiveIcon,
      key: "email_archive",
    },
    {
      title: "Document",
      url: "/document",
      icon: FileTextIcon,
      params: "?page=1",
      key: "document",
    },
    // {
    //   title: "Uom Conversion",
    //   url: "/uom-conversion",
    //   icon: FileTextIcon,
    // },
    // {
    //   title: "Classification",
    //   url: "/classification",
    //   icon: NetworkIcon,
    // },
    {
      title: "Settings",
      url: "/settings",
      icon: NetworkIcon,
      hide: true,
      key: "",
    },
    {
      title: "Profile",
      url: "/profile",
      icon: NetworkIcon,
      hide: true,
      key: "",
    },
    {
      title: "Workflow",
      url: "/workflow",
      icon: WorkflowIcon,
      key: "workflow",
    },
    {
      title: "Email Listener",
      url: "/email-listener",
      icon: MailIcon,
      key: "email_listener",
    },
    {
      title: "Validation",
      url: "/validation",
      icon: CopyPlusIcon,
      key: "validation",
    },
    {
      title: "Terminal Key",
      url: "/terminal-key",
      icon: SquareTerminalIcon,
      key: "terminal_keys",
    },
    {
      title: "User Activity Logs",
      url: "/user-activity",
      icon: FileSpreadsheet,
      key: "user_activity_logs",
    },
    {
      title: "Email read logs",
      url: "/email-read-logs",
      icon: FileSpreadsheet,
      key: "email_read_logs",
    },

    {
      title: "Reports",
      url: "/reports/cash-balance-report",
      icon: FileSpreadsheet,
      key: "reports",
    },
  ],
};
